import Card from "components/card";
import React, { useCallback, useEffect, useState } from "react";
import { MdAttachMoney, MdDownload, MdRefresh } from "react-icons/md";
import { generatePaymentBatches, listPaymentBatches, triggerPayouts } from "stores/ApiHelper";
import ResponseTable from "./components/ResponseTable";

export const AutomatedPayoutOps: React.FC<{}> = () => {
  const [tableData, setTableData] = useState<any>();
  const [error, setError] = useState<any>();
  const [popoverOpen, setPopoverOpen] = React.useState<boolean>(false);

  // util fn
  const setTableDataWithApiCall = useCallback(async (apiCallback: () => Promise<any>) => {
    try {
      setError(null);
      setTableData(null);
      const batchResp = await apiCallback();
      const { data: { results, ...rest } } = batchResp;
      const tableData = {
        ...rest,
        'Payment Batches': results
      };
      setTableData(tableData);
    } catch (e) {
      setError(e);
    }
  }, []);

  const listCurrentBatches = useCallback(async () => {
    setTableDataWithApiCall(listPaymentBatches);
  }, [setTableDataWithApiCall]);

  const generateBatches = useCallback(async () => {
    setTableDataWithApiCall(generatePaymentBatches);
  }, [setTableDataWithApiCall]);

  const downloadCurrentBatchList = useCallback(async () => {
    const resp = await listPaymentBatches(true);
    window.open(resp.data.fileUrl, '_blank', 'noreferrer');
  }, []);

  const executePayouts = useCallback(async () => {
    setTableData(null);
    await triggerPayouts();
    listCurrentBatches();
    setPopoverOpen(false);
  }, [listCurrentBatches]);

  const tooglePopover = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setPopoverOpen(!popoverOpen);
  }

  // Get payment batch list on page load
  useEffect(() => {
    listCurrentBatches();
  }, [listCurrentBatches]);

  return <Card extra={'w-full h-full sm:overflow-auto'}>
    <header className="relative flex items-center justify-between px-6 pt-4">
      <div className="text-xl font-bold text-navy-700 dark:text-white">Payment Batches</div>
    </header>

    <div className="mt-10 flex flex-row justify-end gap-3 px-6">
      <button
        onClick={generateBatches}
        className="flex flex-row items-center rounded-xl bg-gray-100 px-4 py-3 text-sm font-medium text-navy-700 transition duration-200 hover:bg-gray-200 active:bg-gray-300 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
      >
        Generate <MdRefresh className="text-lg" />
      </button>
      <button
        onClick={downloadCurrentBatchList}
        className="flex flex-row items-center rounded-xl bg-gray-100 px-4 py-3 text-sm font-medium text-navy-700 transition duration-200 hover:bg-gray-200 active:bg-gray-300 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
      >
        Download <MdDownload className="text-lg" />
      </button>

      <button
        disabled={tableData?.success === 0}
        className="flex flex-row items-center rounded-xl px-4 py-3 text-sm font-medium transition duration-200 hover:bg-brand-600 bg-brand-700 disabled:opacity-40 text-white"
        type="button"
        onClick={tooglePopover}
      >
        Trigger Payouts <MdAttachMoney className="text-lg" />
      </button>

      {
        popoverOpen ? (
          <div className="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                  <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                    <div className="sm:flex sm:items-start">
                      <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                        <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
                        </svg>
                      </div>
                      <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                        <h6 className="shrink text-[16px] font-bold capitalize text-navy-700 dark:text-white">
                          Are you sure?
                        </h6>

                        <div className="mt-2">
                          <p className="shrink text-[18px] font-bold text-navy-700 dark:text-white" >This will trigger payouts.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                    <button onClick={executePayouts} type="submit" className="inline-flex w-full justify-center rounded-md bg-brand-700 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-brand-600 sm:ml-3 sm:w-auto">Proceed <MdAttachMoney className="text-lg" />
                    </button>
                    <button onClick={tooglePopover} type="button" className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null
      }
    </div>

    {(tableData || error) && <ResponseTable data={tableData} responseError={error} />}
  </Card>
}
